<template>
  <v-dialog
    :value="enableDialog"
    persistent width="1400"
    @click:outside="cancelButtonClickEvent"
    @keydown.esc="cancelButtonClickEvent"
  >
    <v-card>
      <v-card-title>
        収運・処分業者の検索
      </v-card-title>
      <v-divider />
      <v-card-text class="px-2 card-layer" style="height: 70vh;max-height: 80vh;overflow-y: auto;">
        <v-card flat>
          <v-card-subtitle class="px-2">
            <!-- 検索ブロック -->
            <v-expansion-panels v-model="panel" accordion>
              <v-expansion-panel>
                <v-expansion-panel-header class="panel-header-color panel-selectable">
                  <strong>
                    <v-icon class="panel-header-color">
                      mdi-magnify
                    </v-icon>
                    &nbsp;条件を指定して検索
                  </strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-card-text>
                      <!-- 検索範囲 -->
                      <v-row>
                        <v-col cols="12">
                          <v-radio-group v-model="searchForm.mode" row dense hide-details="auto" label="検索範囲">
                            <v-radio v-for="n in modes" :key="n.value" :label="n.text" :value="n.value" />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <!-- /検索範囲 -->
                      <v-row>
                        <!-- 事業者コード -->
                        <v-col cols="12" md="4">
                          <v-text-field v-model="searchForm.code" dense hide-details="auto"
                            :label="searchForm.mode === 'trader' ? '事業者コード' : '事業場コード'" clearable outlined
                            persistent-placeholder placeholder="例）K001" rounded @blur="searchTraders"
                            @click:clear="searchForm.code = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /事業者コード -->
                        <!-- 加入者番号 -->
                        <v-col v-if="searchForm.mode === 'trader'" cols="12" md="4">
                          <v-text-field v-model="searchForm.subscriberNo" dense hide-details="auto" label="加入者番号"
                            clearable outlined persistent-placeholder placeholder="例）1234567" rounded @blur="searchTraders"
                            @click:clear="searchButtonClickEvent()" />
                        </v-col>
                        <!-- /加入者番号 -->
                         <!-- 名称 -->
                        <v-col cols="12" md="4">
                          <v-text-field v-model="searchForm.name" dense hide-details="auto" label="名称" clearable outlined
                            persistent-placeholder placeholder="部分一致で検索" rounded @blur="searchTraders"
                            @click:clear="searchForm.name = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /名称 -->
                      </v-row>
                      <v-row>
                        <!-- 郵便番号 -->
                        <v-col cols="12" md="2">
                          <v-text-field v-model="searchForm.zipCode" dense label="郵便番号" hide-details="auto"
                            hint="ハイフンを含めて入力してください" clearable outlined persistent-placeholder placeholder="例）111-1111"
                            rounded @blur="searchTraders" @click:clear="searchForm.zipCode = null; searchButtonClickEvent()">
                          </v-text-field>
                        </v-col>
                        <!-- /郵便番号 -->
                        <!-- 都道府県コードのみ -->
                        <v-col cols="12" md="2">
                          <v-select v-model="searchForm.prefectureCode" :items="prefList" clearable dense
                            hide-details="auto" label="都道府県" outlined persistent-placeholder placeholder="例）東京都"
                            rounded @change="searchTraders"  />
                        </v-col>
                        <!-- /都道府県コードのみ -->
                        <!-- 町域・詳細住所 -->
                        <v-col cols="12" md="5">
                          <v-text-field v-model="searchForm.address" dense label="市区町村・町域・詳細住所" hide-details="auto"
                            clearable outlined persistent-placeholder placeholder="例）中央区日本橋兜町１－２－３○○ビル○階" rounded @blur="searchTraders"
                            @click:clear="searchForm.address = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /町域・詳細住所 -->
                        <!-- 電話番号 -->
                        <v-col cols="12" md="3">
                          <v-text-field v-model="searchForm.phoneNumber" autocomplete="off" dense
                            hint="電話番号を「-」ハイフン「( )」込みで入力します" hide-details="auto" label="電話番号" clearable outlined
                            persistent-placeholder placeholder="例）000-0000-0000" persistent-hint rounded @blur="searchTraders"
                            @click:clear="searchForm.phoneNumber = null; searchButtonClickEvent()" />
                        </v-col>
                      </v-row>
                      <!-- /電話番号 -->
                    </v-card-text>
                  </v-card>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="searchAndClosePanel">
                      検索
                    </v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- /検索ブロック -->
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  <v-data-table 
                    :headers="tableHeaders" 
                    :items="traders" 
                    :items-per-page="-1" 
                    item-key="key"
                    disable-sort 
                    hide-default-footer 
                    single-select 
                    @click:row="rowClickEvent"
                    @dblclick:row="rowDoubleClickEvent"
                  >
                    <template v-slot:[`item.name`]="{ item }">
                      <div
                        :title="item.name"
                        :class="item.disabled ? 'text--disabled' : ''"
                        class="ellipsis-text float-left"
                        style="max-width: 300px;width: initial;font-size: 90%;"
                      >
                        {{ item.name }}
                      </div>
                      <v-tooltip top :open-on-hover="false">
                        <template #activator="{ on }">
                          <v-btn icon tile small retain-focus-on-click @click="on.click" @blur="on.blur">
                            <v-icon small>mdi-map-marker-outline</v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <small>〒{{ item.zip_code }}<br />{{ item.address }}</small>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.location.name`]="{ item }">
                      <div :class="item.disabled ? 'text--disabled' : ''" :title="item.location.name"
                        style="font-size: 90%">
                        {{ item.location.name | truncate(15) }}
                      </div>
                    </template>
                    <template v-slot:[`item.location.address`]="{ item }">
                      <small :class="item.disabled ? 'text--disabled' : ''">
                        〒{{ item.location.zip_code }}
                      </small>
                      <div :class="item.disabled ? 'text--disabled' : ''" :title="item.location.address"
                        style="font-size: 90%">
                        {{ item.location.address | truncate(15) }}
                      </div>
                    </template>
                    <template v-slot:[`item.billing_address_name`]="{ item }">
                      <div v-if="item.billing_address" :class="item.disabled ? 'text--disabled' : ''"
                        :title="item.billing_address.name" style="font-size: 90%">
                        {{ item.billing_address.name | truncate(20) }}
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-pagination v-model="page" :length="pagination.total_pages" :total-visible="totalVisible" circle
                  prev-icon="mdi-menu-left" next-icon="mdi-menu-right" @input="pageChangeEvent" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancelButtonClickEvent" @mousedown.prevent>
          閉じる
        </v-btn>
        <v-btn color="primary" :disabled="!selectedItem" @click="registerButtonClickEvent">
          反映
        </v-btn>
        <v-snackbar v-model="snackbar" color="red accent-2" :timeout="timeout">
          {{ message }}

          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import PrefectureList from '../../../mixins/PrefectureList'
import { mapActions, mapState } from "vuex";
export default {
  name: 'SearchTraderDialog',
  components: {},
  mixins: [PrefectureList],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      panel: [],
      page: 1,
      totalVisible: 7,
      traders: [],
      selectedItem: null,
      selectedRow: null,
      tableHeaders: [
        { text: '収集・運搬業者', value: 'name' },
        { text: '収集・運搬事業場', value: 'location.name' },
        { text: '事業場住所', value: 'location.address' },
        { text: '請求先', value: 'billing_address_name' },
      ],
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' }
      ],
      searchForm: {
        mode: "trader",
        code: null,
        subscriberNo: null,
        name: null,
        zipCode: null,
        prefectureCode: null,
        address: null,
        manifestType: null,
        phoneNumber: null,
      },
      modes: [
        { value: "trader", text: "収集・運搬業者" },
        { value: "traderLocation", text: "収集・運搬事業場" },
      ],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      snackbar: false,
      message: null,
      timeout: 5000,
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      useBilling: 'use_billing',
    }),
  },
  watch: {
    useBilling(newValue) {
      this.setTableHeader(newValue)
    },
    enableDialog() {
      // 検索パネルを開いた状態にする.
      this.panel = 0
      this.scrollToTop()
      this.traders = []
      this.page = 1
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      this.setTableHeader(this.useBilling)
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
    },
  },
  created() { },
  methods: {
    ...mapActions('DriverMasterSearchTraderDetail', {
      fetchTraderDetails: 'index',
    }),
    ...mapActions('DriverMasterSearchJipCode', {
      fetchJipCode: 'show'
    }),
    setTableHeader(newValue) {
      let table_headers = [
        { text: '収集・運搬業者', value: 'name' },
        { text: '収集・運搬事業場', value: 'location.name' },
        { text: '事業場住所', value: 'location.address' },
      ]
      if (newValue) {
        table_headers.push({ text: '請求先', value: 'billing_address_name' })
      }
      this.tableHeaders = table_headers
    },
    pageChangeEvent() {
      this.searchTraders()
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1
      this.searchTraders()
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent() {
      this.$emit('cancelCallback')
    },
    registerButtonClickEvent() {
      let params = this.buildCheckParam()
      this.fetchJipCode({ params: params }).then((content) => {
        if (content.message) {
          this.message = content.message
          this.snackbar = true
        } else {
          this.$emit('registerCallback', this.selectedItem)
        }
      })
    },
    buildCheckParam() {
      return {
        zip_code: this.selectedItem.zip_code,
        prefecture_code: this.selectedItem.prefecture_code,
        address_1: this.selectedItem.address_1,
        location_zip_code: this.selectedItem.location.zip_code,
        location_prefecture_code: this.selectedItem.location.prefecture_code,
        location_address_1: this.selectedItem.location.address_1,
      }
    },
    rowClickEvent(item, row) {
      if (item.disabled) {
        if (this.selectedRow) {
          this.selectedRow.select(false)
          this.selectedRow = null
          this.selectedItem = null
        }
        return false
      }
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("registerCallback", row.item);
    },
    searchTraders() {
      if (!this.enableDialog) return false;

      let params = this.buildParam()
      this.fetchTraderDetails({ params: params }).then((content) => {
        this.scrollToTop()
        this.traders = content.traders
        this.pagination = content.pagination
      })
    },
    searchAndClosePanel() {
      let params = this.buildParam()
      this.fetchTraderDetails({ params: params }).then((content) => {
        this.scrollToTop()
        this.panel = []
        this.traders = content.traders
        this.pagination = content.pagination
      })
    },
    buildParam() {
      return {
        mode: this.searchForm.mode,
        code: this.searchForm.code,
        subscriber_no: this.searchForm.mode === 'trader' ? this.searchForm.subscriberNo : null,
        name: this.searchForm.name,
        zip_code: this.searchForm.zipCode,
        prefecture_code: this.searchForm.prefectureCode,
        address: this.searchForm.address,
        phone_number: this.searchForm.phoneNumber,
        page: this.page
      }
    },
    scrollToTop() {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  }
}
</script>
